import { useState } from 'react';

import { IonIcon, IonText, IonImg } from '@ionic/react';

import { informationCircleOutline } from 'ionicons/icons';

import { getUrlFromPath } from 'libs/helpers/helper.lib';
import CustomModal from 'components/CustomModal';

import classes from './style.module.scss';

const WorkoutInfoContainer = ({ workoutAssignment }) => {
  const [popoverState, setShowPopover] = useState(false);

  return (
    <div className={classes.workoutTitleHead}>
      <IonImg
        className={classes.image}
        src={getUrlFromPath(workoutAssignment.workout.cover)}
        alt={workoutAssignment.workout.name}
      />
      <div className={classes.workoutInfoContainer}>
        {workoutAssignment.workout.type === 'CORRECTIVE' && (
          <div className={classes.workoutInfoType}>
            <IonText className='big'>
              {workoutAssignment.workout.type.toLowerCase()}
            </IonText>
          </div>
        )}
        <div className={classes.workoutInfo}>
          <IonText>{workoutAssignment.workoutAssignmentCategory.name}</IonText>

          <div className={classes.workoutCategoryDescription}>
            <IonText className='big'>{workoutAssignment.workout.name}</IonText>
            <IonIcon
              icon={informationCircleOutline}
              size='large'
              onClick={(e) => {
                e.stopPropagation();
                setShowPopover(true);
              }}
            />
            <CustomModal
              isOpen={popoverState}
              dismiss={() => setShowPopover(false)}
              title='Notes'
              content={workoutAssignment.notes}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutInfoContainer;
